import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProductSpecification } from 'situview-webapi-client';

@Component({
  selector: 'product-specification-tree-dialog',
  templateUrl: './product-specification-tree-dialog.component.html',
  styleUrls: ['./product-specification-tree-dialog.component.scss']
})
export class ProductSpecificationTreeDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ProductSpecificationTreeDialogData,
    private dialogRef: MatDialogRef<ProductSpecificationTreeDialogData>) {
      data.productSpecificationIds = [...data.productSpecificationIds];
  }

  onProductSpecificationSelectionChanged(selectedProductSpecificationIds: string[]) {
    if (this.data.productSpecificationIds) {
      this.data.productSpecificationIds = selectedProductSpecificationIds;
    }
  }

  nagivateBack() {
    this.dialogRef.close();
  }

  onConfirmSelection() {
    this.dialogRef.close(this.getReturnData());
  }

  getReturnData(): ProductSpecificationTreeResultData {
    return { 
      selectedProductSpecificationIds: this.data.productSpecificationIds,
    } as ProductSpecificationTreeResultData;
  }
}

export interface ProductSpecificationTreeDialogData {
  productSpecificationIds: string[];
  productTypeIdFilter: string;
  productSpecifications: ProductSpecification[];
}

export interface ProductSpecificationTreeResultData {
  selectedProductSpecificationIds: string[];
}